
import axios, { AxiosResponse } from 'axios'
import { ICashRegisterModel } from './CashRegisterModel'
import { ApiResponse, PageResponse } from '../../../../shared/models/ApiModels'

const API_URL = (process.env.REACT_APP_API_URL || '/').replace(/\/?$/, '/')

export const CASH_REGISTER_CREATE_URL = `${API_URL}api/v1/definition/cashRegister/create`
export const CASH_REGISTER_GET_ALL_URL = `${API_URL}api/v1/definition/cashRegister/all`
export const CASH_REGISTER_DELETE_URL = `${API_URL}api/v1/definition/cashRegister/delete/`
export const CASH_REGISTER_UPDATE_URL = `${API_URL}api/v1/definition/cashRegister/update/`

export function createCashRegister(payload: ICashRegisterModel) {
  return axios.post(CASH_REGISTER_CREATE_URL, payload)
}

export function updateCashRegister(payload: ICashRegisterModel) {
  return axios.patch(CASH_REGISTER_UPDATE_URL, payload)
}

export function deleteCashRegister(id: number | string) {
  return axios.delete(CASH_REGISTER_DELETE_URL + id)
}

export async function allCashRegister(
  page = 0,
  size = 10,
  sort: string = 'createdDate',
  order: 'asc' | 'desc' = 'desc'
): Promise<AxiosResponse<ApiResponse<PageResponse<ICashRegisterModel>>>> {
  return axios.get(CASH_REGISTER_GET_ALL_URL, { params: { page, size, sort, order } })
}
